import React, { useState, useEffect, useRef } from 'react'
import { Card, Col, Container, Modal, Row } from "react-bootstrap";
import axios from "axios";

export default function CommentModal({ show, onHide, commentModalData, getVideFeedComment }) {

    const greetings = [
        { message: "Wow!", value: "wow", icon: "thumbs-up" },
        { message: "Amazing!", value: "amazing", icon: "star" },
        { message: "Great job!", value: "great_job", icon: "trophy" },
        { message: "Welcome!", value: "welcome", icon: "handshake" },
        { message: "You're awesome!", value: "awesome", icon: "smile" }
    ];

    const [videoId, auditionId, roundId] = commentModalData;
    const [isSubmitting, setIsSubmitting] = useState(false);
    const isMountedRef = useRef(true);

    useEffect(() => {
      return () => {
        isMountedRef.current = false;
      };
    }, []);

    const handlePress = async (greeting) => {
        const [value, message] = greeting;

        const data = {
            videoId: videoId,
            audition_id: auditionId,
            round_id: roundId,
            comment: message,
            comment_type: value,
        };

        setIsSubmitting(true);

        try {
            // Post comment directly to API and wait for response
            const res = await axios.post("api/user/audition/video/comment", data);
            
            if (res.data.status === 200 || res.data.status === 422) {
                // Close modal only after successful API response
                onHide();
                // Refresh comment list
                getVideFeedComment(videoId);
            }
        } catch (error) {
            console.error("Error posting comment:", error);
        } finally {
            if (isMountedRef.current) {
                setIsSubmitting(false);
            }
        }
    };

    return (
        <Modal
            show={show}
            onHide={onHide}
            aria-labelledby="contained-modal-title-vcenter"
            className='comment-modal'
            centered
        >
            <Modal.Body>
                <Card sx={{ minWidth: 200 }} style={{ backgroundColor: 'transparent' }}>
                    <Container>
                        <Row>
                            <Col md="10">
                                {greetings.map((greeting, index) => (
                                    <button
                                        style={{ 
                                            backgroundColor: "transparent", 
                                            color: "white",
                                            opacity: isSubmitting ? 0.6 : 1,
                                            cursor: isSubmitting ? "not-allowed" : "pointer"
                                        }}
                                        key={index}
                                        onClick={() => {
                                            handlePress([greeting.value, greeting.message]);
                                        }}
                                        disabled={isSubmitting}
                                    >
                                        <p>
                                            {greeting.message}{" "}
                                            <i className={`fa fa-${greeting.icon}`}></i>
                                            {isSubmitting && (
                                                <span className="ms-2">
                                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                </span>
                                            )}
                                        </p>
                                    </button>
                                ))}
                            </Col>
                        </Row>
                    </Container>
                </Card>
            </Modal.Body>
        </Modal>
    )
}